import { defineStore } from 'pinia';
import {
  createBaseFilterState,
  createFilterActions,
  createFilterGetters,
} from './filterStoreHelpers';
import sortOptions from '@/constants/sortOptions';

const filterAPI = 'api/transport-requests/manage/Pending-Offer';
const options = { sort: sortOptions.recentlyUpdated };

export const usePendingFilterStore = defineStore('pendingFilterStore', {
  state: () => createBaseFilterState(options),
  actions: createFilterActions(filterAPI, options),
  getters: createFilterGetters(),
});
